var _g, _g2, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRibbon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 65,
    viewBox: "0 0 328 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_295_626)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 328,
    height: 16,
    transform: "matrix(-1 0 0 1 328 19)",
    fill: "#2348AB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_295_626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.922 23.9525C272.905 23.5765 281.391 26.0474 287.359 30.5594C292.827 34.6933 297.431 39.2611 297.602 39.7446C297.644 39.8661 297.418 40.6907 297.059 41.9929C295.992 45.8693 293.761 53.9779 294.017 60.3709C292.703 59.1949 290.338 56.4656 287.975 53.7385C286.345 51.8567 284.715 49.976 283.432 48.6074C279.506 44.4177 270.977 37.4886 263.295 31.3651L268.922 23.9525Z",
    fill: "#2348AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.958 24.24C253.936 23.8637 244.925 24.0788 241.064 27.9493C238.54 30.4787 234.838 33.8898 231.856 36.6384C229.133 39.1471 227.01 41.104 226.927 41.3349C226.885 41.4551 227.108 42.2028 227.462 43.3899C228.535 46.9795 230.807 54.5867 230.548 61.01C231.132 60.4911 231.994 59.7579 233.004 58.8978C235.867 56.4611 239.926 53.0067 242.27 50.5273C242.551 50.2308 242.868 49.8964 243.217 49.5286C247.806 44.6951 257.869 34.0939 261.234 27.9493L257.958 24.24Z",
    fill: "#2348AB"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_295_626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.626 14.6438C270.799 14.0976 270.984 13.5149 271.229 12.892C272.61 9.3756 278.996 1.54352 280.895 0.424649C282.794 -0.694221 284.52 0.424648 288.49 3.46158C289.879 4.52445 291.48 5.56774 292.967 6.53664C295.728 8.33617 298.095 9.87907 297.983 10.8141C297.81 12.2527 287.799 22.4824 283.312 25.1996C278.824 27.9169 269.158 27.5972 265.015 25.1996L264.152 20.2446C269.265 18.9293 269.82 17.1812 270.626 14.6438Z",
    fill: "#2348AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.744 14.43C252.552 14.0555 252.352 13.6661 252.135 13.2606C250.95 11.0468 248.691 8.25091 246.623 5.69248C245.087 3.79061 243.656 2.01994 242.851 0.717084C242.332 -0.123639 239.584 1.03871 235.63 4.09418C234.013 5.3433 232.109 6.45804 230.435 7.43839C228.014 8.85608 226.072 9.99275 226.174 10.8484C226.346 12.2957 234.079 22.7486 240.788 25.3217C245.729 27.2169 253.855 28.0555 257.981 25.6433L259.528 20.6581C255.14 19.1022 254.146 17.1645 252.744 14.43Z",
    fill: "#2348AB"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_295_626)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.37 16.161C258.756 16.6373 255.925 16.161 255.171 16.5203C254.145 21.1684 255.522 29.1968 258.082 33.36C259.401 33.7193 264.548 33.5709 265.302 33.3912C270.081 28.3767 270.792 16.5203 269.662 16.161C268.531 15.8017 262.886 15.4181 260.37 16.161Z",
    fill: "#2348AB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_295_626",
    x: 0,
    y: 19,
    width: 328,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_295_626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_295_626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_295_626",
    x: 225.922,
    y: 23.915,
    width: 73.6846,
    height: 41.095,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_295_626"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_295_626",
    result: "effect2_dropShadow_295_626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_295_626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_295_626",
    x: 226.17,
    y: -0.0000610352,
    width: 71.817,
    height: 31.1265,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_295_626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_295_626",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_295_626",
    x: 253.829,
    y: 15.7358,
    width: 18.3017,
    height: 21.8442,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_295_626"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_295_626",
    result: "effect2_dropShadow_295_626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_295_626",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbon);
export default __webpack_public_path__ + "static/media/ribbon.b9814015fb87a57441199387ac311304.svg";
export { ForwardRef as ReactComponent };